(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["room-mockup-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRoomMockup = (root) => {
      if (!root || root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';
      root.classList.add('is-enhanced');

      const form = root.querySelector('[data-room-mockup-form]');
      if (!form) return;

      const panels = [...root.querySelectorAll('[data-step-panel]')];
      const indicators = [...root.querySelectorAll('[data-step-indicator]')];
      const stepCopies = [...root.querySelectorAll('[data-step-copy]')];
      const nextButton = root.querySelector('[data-next-step]');
      const previousButton = root.querySelector('[data-prev-step]');
      const fileInput = root.querySelector('[data-file-input]');
      const uploadZone = root.querySelector('[data-upload-zone]');
      const dropLabel = root.querySelector('[data-drop-label]');
      const preview = root.querySelector('[data-file-preview]');
      const previewImage = root.querySelector('[data-preview-image]');
      const fileName = root.querySelector('[data-file-name]');
      const fileSize = root.querySelector('[data-file-size]');
      const removeButton = root.querySelector('[data-remove-file]');
      const submitButton = root.querySelector('[data-submit-button]');
      const submitLabel = root.querySelector('[data-submit-label]');
      const submitStatus = root.querySelector('[data-submit-status]');
      const successPanel = root.querySelector('[data-success-panel]');
      const resetButton = root.querySelector('[data-reset-form]');
      const maxFileSize = 20 * 1024 * 1024;

      const defaultSubmitLabel = submitLabel
        ? submitLabel.textContent
        : 'Request my preview';

      let previewUrl = '';

      if (
        form.getAttribute('action') &&
        form.getAttribute('action').trim()
      ) {
        submitButton.disabled = false;
      }

      const showStep = (step, shouldFocus = true) => {
        panels.forEach((panel) => {
          panel.classList.toggle(
            'is-active',
            panel.dataset.stepPanel === String(step)
          );
        });

        indicators.forEach((indicator) => {
          const indicatorStep = Number(indicator.dataset.stepIndicator);

          indicator.classList.toggle(
            'is-active',
            indicatorStep === step
          );

          indicator.classList.toggle(
            'is-complete',
            indicatorStep < step
          );

          if (indicatorStep === step) {
            indicator.setAttribute('aria-current', 'step');
          } else {
            indicator.removeAttribute('aria-current');
          }
        });

        stepCopies.forEach((copy) => {
          const isActive = copy.dataset.stepCopy === String(step);

          copy.hidden = !isActive;
          copy.classList.toggle('is-active', isActive);
        });

        if (shouldFocus) {
          const activePanel = panels.find(
            (panel) => panel.dataset.stepPanel === String(step)
          );

          const headingCandidates = [
            root.querySelector(`[data-step-copy="${step}"] h3`),
            activePanel && activePanel.querySelector('h3')
          ].filter(Boolean);

          const heading =
            headingCandidates.find(
              (candidate) => candidate.getClientRects().length
            ) || null;

          if (heading) {
            heading.setAttribute('tabindex', '-1');

            heading.focus({
              preventScroll: true
            });
          }

          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      };

      const validateFirstStep = () => {
        const controls = [
          ...panels[0].querySelectorAll(
            'input, textarea, select'
          )
        ].filter((control) => {
          return (
            !control.disabled &&
            control.type !== 'hidden' &&
            control.type !== 'button'
          );
        });

        const firstInvalid = controls.find(
          (control) => !control.checkValidity()
        );

        if (!firstInvalid) {
          return true;
        }

        firstInvalid.focus();
        firstInvalid.reportValidity();

        return false;
      };

      const humanFileSize = (bytes) =>
        bytes >= 1024 * 1024
          ? `${(bytes / (1024 * 1024)).toFixed(1)} MB`
          : `${Math.max(1, Math.round(bytes / 1024))} KB`;

      const clearPreviewUrl = () => {
        if (previewUrl) {
          URL.revokeObjectURL(previewUrl);
        }

        previewUrl = '';
      };

      const clearFilePreview = () => {
        clearPreviewUrl();

        preview.hidden = true;
        dropLabel.hidden = false;
        previewImage.removeAttribute('src');

        if (fileName) {
          fileName.textContent = '';
        }

        if (fileSize) {
          fileSize.textContent = '';
        }
      };

      const resetFile = () => {
        clearFilePreview();

        fileInput.value = '';
        fileInput.setCustomValidity('');
      };

      const showFileValidation = (message) => {
        fileInput.setCustomValidity(message);
        fileInput.focus();
        fileInput.reportValidity();
      };

      const presentFile = (file, reportErrors = true) => {
        fileInput.setCustomValidity('');

        if (!file) {
          clearFilePreview();
          return false;
        }

        if (
          file.type &&
          !file.type.startsWith('image/')
        ) {
          clearFilePreview();
          fileInput.value = '';

          if (reportErrors) {
            showFileValidation(
              'Please choose an image file.'
            );
          } else {
            fileInput.setCustomValidity(
              'Please choose an image file.'
            );
          }

          return false;
        }

        if (file.size > maxFileSize) {
          clearFilePreview();
          fileInput.value = '';

          if (reportErrors) {
            showFileValidation(
              'That image is larger than 20 MB. Please choose a smaller version.'
            );
          } else {
            fileInput.setCustomValidity(
              'That image is larger than 20 MB. Please choose a smaller version.'
            );
          }

          return false;
        }

        clearPreviewUrl();

        previewUrl = URL.createObjectURL(file);

        previewImage.src = previewUrl;
        fileName.textContent = file.name;
        fileSize.textContent = humanFileSize(file.size);

        dropLabel.hidden = true;
        preview.hidden = false;

        fileInput.setCustomValidity('');

        return true;
      };

      nextButton.addEventListener('click', () => {
        if (validateFirstStep()) {
          showStep(2);
        }
      });

      previousButton.addEventListener('click', () => {
        showStep(1);
      });

      fileInput.addEventListener('change', () => {
        fileInput.setCustomValidity('');

        presentFile(
          fileInput.files[0]
        );
      });

      removeButton.addEventListener('click', () => {
        resetFile();
      });

      ['dragenter', 'dragover'].forEach((eventName) => {
        uploadZone.addEventListener(eventName, (event) => {
          event.preventDefault();

          uploadZone.classList.add(
            'is-dragging'
          );
        });
      });

      ['dragleave', 'drop'].forEach((eventName) => {
        uploadZone.addEventListener(eventName, (event) => {
          event.preventDefault();

          uploadZone.classList.remove(
            'is-dragging'
          );
        });
      });

      uploadZone.addEventListener('drop', (event) => {
        const droppedFile =
          event.dataTransfer &&
          event.dataTransfer.files &&
          event.dataTransfer.files[0];

        if (!droppedFile) return;

        try {
          const transfer =
            new DataTransfer();

          transfer.items.add(
            droppedFile
          );

          fileInput.files =
            transfer.files;

          presentFile(
            droppedFile
          );
        } catch (error) {
          showFileValidation(
            'Please use “choose a file” to add this image.'
          );
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        submitStatus.textContent = '';

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (!presentFile(fileInput.files[0])) {
          return;
        }

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        submitLabel.textContent = 'Sending your request';

        try {
          const response =
            await fetch(
              form.action,
              {
                method: 'POST',
                body: new FormData(form),
                headers: {
                  Accept:
                    'application/json'
                }
              }
            );

          if (!response.ok) {
            const result =
              await response
                .json()
                .catch(() => ({}));

            const message =
              result.errors &&
              result.errors.length
                ? result.errors
                    .map(
                      (error) =>
                        error.message
                    )
                    .join(' ')
                : 'We couldn’t send your request. Please try again.';

            throw new Error(
              message
            );
          }

          form.hidden = true;
          successPanel.hidden = false;

          successPanel.setAttribute(
            'tabindex',
            '-1'
          );

          successPanel.focus({
            preventScroll: true
          });

          root.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        } catch (error) {
          submitStatus.textContent =
            error.message ||
            'We couldn’t send your request. Please try again.';
        } finally {
          submitButton.disabled = false;

          submitButton.classList.remove(
            'is-loading'
          );

          submitLabel.textContent =
            defaultSubmitLabel;
        }
      });

      resetButton.addEventListener('click', () => {
        form.reset();
        resetFile();

        successPanel.hidden = true;
        form.hidden = false;

        showStep(1, false);

        const firstInput =
          form.querySelector(
            'input:not([type="hidden"])'
          );

        if (firstInput) {
          firstInput.focus();
        }
      });

      showStep(1, false);
    };

    const initializeAllRoomMockups = (
      scope = document
    ) => {
      scope
        .querySelectorAll(
          '[data-room-mockup]'
        )
        .forEach(
          initializeRoomMockup
        );
    };

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initializeAllRoomMockups();
        }
      );
    } else {
      initializeAllRoomMockups();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAllRoomMockups(
          event.target
        );
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
